import ReactGA from "react-ga4";

// Replace with your actual Google Analytics Measurement ID
export const GA_MEASUREMENT_ID = "G-9YB27L06NF";

export const initGA = () => {
  if (typeof window !== "undefined") {
    ReactGA.initialize(GA_MEASUREMENT_ID, {
      gaOptions: {
        anonymizeIp: true,
      },
    });
  }
};

export const logPageView = (path: string) => {
  if (typeof window !== "undefined") {
    ReactGA.send({ hitType: "pageview", page: path });
  }
};

export const logEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number
) => {
  if (typeof window !== "undefined") {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  }
};

export const logCustomEvent = (
  eventName: string,
  params?: Record<string, any>
) => {
  if (typeof window !== "undefined") {
    ReactGA.event(eventName, params);
  }
};
